import {scheduleDataHooks as DH} from '@wix/wix-events-data-hooks'
import {LocationSmall} from '@wix/wix-ui-icons-common'
import {Dialog, Text} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import xss from 'xss'
import {ModalContext, ModalType} from '../../../hooks/modal'
import {useWidgetProps} from '../../../hooks/widget-props'
import {getScheduleItemDescription, isScheduleItemCanceled} from '../../../selectors/schedule'
import {Tags} from '../../filters/tags'
import {Indications} from '../../indications'
import {classes as descriptionClasses} from '../../schedule/description/description.st.css'
import {Bookmark} from '../../schedule/item/bookmark'
import ms from '../../schedule/item/mobile.scss'
import {classes as modalClasses} from '../modal.st.css'
import {ScheduleItemProps} from './interfaces'
import {classes} from './schedule-item.st.css'

export const ScheduleItem = ({item}: ScheduleItemProps) => {
  const {host, t, toggleScheduleItemModal} = useWidgetProps()
  const {isMobile} = useEnvironment()
  const preview = host.viewMode === 'Preview'
  const description = getScheduleItemDescription(item)
  const canceled = isScheduleItemCanceled(item)

  return (
    <ModalContext.Provider value={{insideModal: true, modalType: ModalType.SCHEDULE_ITEM}}>
      <Dialog
        className={classNames(modalClasses.root, {
          [modalClasses.previewMode]: preview,
          [modalClasses.mobile]: isMobile,
        })}
        contentClassName={classes.modalContent}
        isOpen={true}
        onClose={() => toggleScheduleItemModal(null)}
        closeButtonAriaLabel={t('aria.dialog.close')}
      >
        <div className={classNames(classes.container, ms.insideModal)}>
          <Indications canceled={canceled} t={t} formattedUpdatedDate={item.formattedUpdatedDate} noTopMargin />
          <div className={ms.timeContainer}>
            <div className={ms.timeSlot}>{item.formattedTimeSlot}</div>
            <Bookmark itemId={item.id} bookmarked={item.bookmarked} />
          </div>
          <div className={ms.duration}>{item.formattedDuration}</div>
          <h2 className={ms.title}>{item.name}</h2>
          {item.location && (
            <div className={ms.location} data-hook={DH.LOCATION}>
              <LocationSmall data-hook={DH.LOCATION_ICON} aria-label={t('aria.scheduleItem.location')} role="img" />
              <span>{item.location}</span>
            </div>
          )}
          {item.tags && <Tags t={t} tags={item.tags} className={ms.tags} />}
          {description && (
            <Text
              className={classNames(descriptionClasses.blackText, descriptionClasses.text)}
              data-hook={DH.DESCRIPTION}
            >
              <div dangerouslySetInnerHTML={{__html: xss(description)}} />
            </Text>
          )}
        </div>
      </Dialog>
    </ModalContext.Provider>
  )
}
